
namespace TabAurous.Sales {
    import fld = SalesItemsBOMRow.Fields;

    @Serenity.Decorators.registerClass()
    export class SalesItemsBOMGrid extends Serenity.EntityGrid<SalesItemsBOMRow, any> {
        protected getColumnsKey() { return 'Sales.SalesItemsBOM'; }
        protected getDialogType() { return SalesItemsBOMDialog; }
        protected getIdProperty() { return SalesItemsBOMRow.idProperty; }
        protected getInsertPermission() { return SalesItemsBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return SalesItemsBOMRow.localTextPrefix; }
        protected getService() { return SalesItemsBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
    } 
}